import { render, staticRenderFns } from "./TftSiderbarContainer.vue?vue&type=template&id=af2cefd0&"
import script from "./TftSiderbarContainer.vue?vue&type=script&lang=js&"
export * from "./TftSiderbarContainer.vue?vue&type=script&lang=js&"
import style0 from "./TftSiderbarContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports